<template>
  <div class="rj-col-3">
    <div class="rj-baseinfo">
      <div class="rj-baseinfo__label">
        币种<span v-if="required" class="required">*</span>：
      </div>
      <div class="rj-baseinfo__item">
        <el-form-item prop="currencyId">
          <el-select ref="taxType" v-model="form.currencyId" placeholder="请选择币种" style="width:100%;" @change="changetaxType">
            <el-option v-for="(item,index) in moneyType" :key="index" :label="item.dictValue" :value="item.dictLabel" />
          </el-select>
        </el-form-item>
      </div>
    </div>
  </div>
</template>
<script type="es6">
import { dictGetDictData } from '@/API';
export default {
  data () {
    return {
      list: [],
      moneyType: [],
      loading: false
    };
  },
  model: {
    prop: 'form',
    event: 'change'
  },
  props: {
    form: {
      type: Object,
      default: () => { return {}; }
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  components: {},
  created () {
    this.getDictData();
  },
  methods: {
    changetaxType (val) {
      this.$nextTick(() => {
        // this.form.taxTypeName = this.$refs.taxType.selectedLabel;
        this.form.currencyName = this.$refs.taxType.selectedLabel;
      });
      this.$emit('changeTaxType', val);
    },
    getDictData () {
      dictGetDictData({
        dictType: 'currency'
      }).then(res => {
        if (res.data.status !== '200') return;
        this.moneyType = res.data.data;
      });
    }
  }
};
</script>
<style lang="less"></style>
